import {ReactNode} from 'react'

type Props = {
  title: string | ReactNode
  children?: ReactNode
}

export const Heading = ({title, children}: Props) => {
  return (
    <header className="heading">
      {typeof title === 'string' ? <h1>{title}</h1> : title}
      {children}
    </header>
  )
}
